// src/services/paymentService.js
// FIXED: Removed all broken [api.post](http://api.post) and [res.data](http://res.data) markdown link syntax

import api from './api';

export const paymentService = {
  initiateInspectionPayment: async (inspectionId) => {
    try {
      const res = await api.post('/payments/initiate', { inspection_id: inspectionId });
      return res.data;
    } catch (error) {
      console.error('Payment initiation error:', error);
      throw error.response?.data || error;
    }
  },

  initiateBookingPayment: async (bookingId) => {
    try {
      const res = await api.post('/payments/initiate', { booking_id: bookingId });
      return res.data;
    } catch (error) {
      console.error('Booking payment initiation error:', error);
      throw error.response?.data || error;
    }
  },

  getPaymentHistory: async () => {
    try {
      const res = await api.get('/payments/history');
      return res.data;
    } catch (error) {
      console.error('Get payment history error:', error);
      throw error.response?.data || error;
    }
  },

  initiateOrderPayment: async (orderId) => {
    try {
      const res = await api.post('/payments/initiate', { order_id: orderId });
      return res.data;
    } catch (error) {
      console.error('Order payment initiation error:', error);
      throw error.response?.data || error;
    }
  },

  confirmPayment: async (paymentId, razorpayResponse) => {
    if (!paymentId) throw new Error('Payment ID missing');
    try {
      const res = await api.post(`/payments/${paymentId}/confirm`, {
        razorpay_order_id: razorpayResponse.razorpay_order_id,
        razorpay_payment_id: razorpayResponse.razorpay_payment_id,
        razorpay_signature: razorpayResponse.razorpay_signature,
      });
      return res.data;
    } catch (error) {
      console.error('Payment confirmation error:', error);
      throw error.response?.data || error;
    }
  },

  getPaymentStatus: async (paymentId) => {
    try {
      const res = await api.get(`/payments/${paymentId}/status`);
      return res.data;
    } catch (error) {
      console.error('Get payment status error:', error);
      throw error.response?.data || error;
    }
  },

  getInspectionPayment: async (inspectionId) => {
    try {
      const res = await api.get(`/payments/inspection/${inspectionId}`);
      return res.data;
    } catch (error) {
      console.error('Get inspection payment error:', error);
      return null;
    }
  },

  refundPayment: async (paymentId) => {
    try {
      const res = await api.post(`/payments/${paymentId}/refund`);
      return res.data;
    } catch (error) {
      console.error('Refund payment error:', error);
      throw error.response?.data || error;
    }
  },
};